/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Date_Picker_ClearInputs */

const fr_date_picker_clear = /** @type {(inputs: Date_Picker_ClearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Effacer la date`)
};

const en_date_picker_clear = /** @type {(inputs: Date_Picker_ClearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clear date`)
};

/**
* | output |
* | --- |
* | "Clear date" |
*
* @param {Date_Picker_ClearInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const date_picker_clear = /** @type {((inputs?: Date_Picker_ClearInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Date_Picker_ClearInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_date_picker_clear(inputs)
	return fr_date_picker_clear(inputs)
});